import { HttpTypes } from "@medusajs/types";

export function getCartQuantityForVariant(
  cart: HttpTypes.StoreCart | null,
  variantId: string
): number {
  return (
    cart?.items?.find((item) => item.variant?.id === variantId)?.quantity ?? 0
  );
}

export function canAddToCart(
  cart: HttpTypes.StoreCart | null,
  variantId: string,
  stock: number,
  quantityToAdd = 1
): boolean {
  const inCart = getCartQuantityForVariant(cart, variantId);
  return inCart + quantityToAdd <= stock && stock > 0;
}

export function maxAddableQuantity(
  cart: HttpTypes.StoreCart | null,
  variantId: string,
  stock: number
): number {
  const inCart = getCartQuantityForVariant(cart, variantId);
  return Math.max(0, stock - inCart);
}
